<template>
    <option value="temperature">Air Temperature</option>
    <option value="vpd">Vapor Pressure Deficit</option>
    <option value="vocs">Volatile Organic Compounds</option>
</template>
